export class EmploymentFilter {
    createdOn: Date[] = [];
    status = [{ value: 'Draft', checked: false }, { value: 'Pending', checked: false }, { value: 'Active', checked: false }, { value: 'Inactive', checked: false }];
    employer: any;
    city: any;

}

